export class UpdateViewerRoleRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "roleId",
            "baseName": "roleId",
            "type": "string",
            "format": "tobedefined"
        }
    ];
    static getAttributeTypeMap() {
        return UpdateViewerRoleRequest.attributeTypeMap;
    }
    constructor() {
    }
}
